import { ProductSubDepartmentUpdatePage } from "@/features/product-sub-department/pages/ProductSubDepartmentUpdatePage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/product-sub-department/$id/update")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["product_sub_department.edit"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ProductSubDepartmentUpdatePage,
});
